var _defs, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnFontControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "124.98 203.55 184.17 203.55 184.17 349.16 233.57 349.14 233.57 203.53 292.83 203.53 292.83 162.84 124.98 162.84 124.98 203.55"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "298.77 251.18 298.77 272.57 329.95 272.57 329.95 349.16 355.96 349.16 355.96 272.57 387.02 272.57 387.02 251.18 298.77 251.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFontControl);
export default __webpack_public_path__ + "static/media/ICN_font-control.f8339053facb6240580dd94748866e09.svg";
export { ForwardRef as ReactComponent };